export const Validator = {
  name: 'exact',

  errorMessage: 'The :attribute should equal to :value.',

  validate: (value, requirement, attribute) => {
    return value === requirement;
  },
};
